import React from "react";
import CarFooter from "../components/CarFooter";
import CarFooterbar from "../components/CarFooterbar";
import "../styles/TextStyle.css";
import "../styles/variables.css";
import axios from "axios";
import { useEffect, useState } from "react";
import Section1 from "../sections/Section1";
import Section4 from "../sections/Section4";
import Section7 from "../sections/Section7";
import Section6_1 from "../sections/Section6_1";

const Azienda = () => {
  const apiEndpointAzienda = `https://gestione.carellidistribuzione.it/react-endpoint-api/get-data-page/azienda?${new Date().getTime()}`;
  const apiEndpointHome = `https://gestione.carellidistribuzione.it/react-endpoint-api/get-data-page/home-page?${new Date().getTime()}`;

  const [sectionsData, setSectionsData] = useState([]);

    const [showLoader, setShowLoader] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);
    

  useEffect(() => {
    const fetchData = async () => {
      try {
      
        const [resAzienda, resHome] = await Promise.all([
          axios.get(apiEndpointAzienda),
          axios.get(apiEndpointHome),
        ]);

        // Ottieni i dati dalle risposte
        const rdAzienda = resAzienda.data;
        const rdHome = resHome.data;
        console.log(rdAzienda.data?.["azienda"]);

        
        const newSectionsData = [
          {
            section: 1,
            breadCrumbs: rdAzienda?.data?.["azienda"]?.["308"]?.breadcrumbs,

            contenuti: [356].map((id) => {
              const contenuto =
                rdAzienda?.data?.["azienda"]?.["312"]?.contenuti?.[id];
              return {
                titolo1: contenuto?.titolo_it,
                immagineBg: contenuto?.immagine_url,
              };
            }),
          },
          {
            section: 7,
            contenuti: [357].map((id) => {
              const contenuto =
                rdAzienda?.data?.["azienda"]?.["313"]?.contenuti?.[id];
              return {
                titolo1: contenuto?.titolo_1,
                titolo2: contenuto?.titolo_2,
                descrizione: contenuto?.descrizione_it,
                immaginiAggiuntive: contenuto?.immagini_aggiuntive?.map(
                  (img) => img.immagine_path
                ),
              };
            }),
            cards: [358, 359, 360].map((id) => {
              const card =
                rdAzienda.data?.["azienda"]?.["313"]?.contenuti?.[id];
              return {
                titolo: card?.titolo_it,
                sottotitolo: card?.sottotitolo_it,
              };
            }),
          },

          {
            section: 4,
            contenuti: [339].map((id) => {
              const contenuto =
                rdHome.data?.["home-page"]?.["308"]?.contenuti?.[id];
              return {
                titolo1: contenuto?.titolo_1,
                titolo2: contenuto?.titolo_2,
                sottotitolo: contenuto?.sottotitolo_it,
                descrizione: contenuto?.descrizione_it,
                immaginiAggiuntive: contenuto?.immagini_aggiuntive,
                callToAction: contenuto?.call_to_action_it,
                link: contenuto?.link_it,
              };
            }),
          },
          {
            section: 6_1,
            contenuti: [361].map((id) => {
              const contenuto =
                rdAzienda.data?.["azienda"]?.["314"]?.contenuti?.[id];
              return {
                titolo1: contenuto?.titolo_1,
                titolo2: contenuto?.titolo_2,
                immagineBg: contenuto?.immagine_url,
                descrizione: contenuto?.descrizione_it,
              };
            }),
            cards: [362, 363, 364, 365, 366, 367].map((id) => {
              const card =
                rdAzienda.data?.["azienda"]?.["314"]?.contenuti?.[id];
              return {
                descrizione: card?.descrizione_it,
                sottotitolo: card?.sottotitolo_it,
                immagine: card?.immagine_url,
              };
            }),
          },
            
        {
          section: 99
        }
        ];

   
        setSectionsData(newSectionsData);
      } catch (error) {
        console.error("Errore durante il caricamento dei dati:", error);
      }
    };

    fetchData();
  }, []); 


      useEffect(() => {
            if (sectionsData.length > 0) {
              setFadeOut(true);
              const timer = setTimeout(() => {
                setShowLoader(false);
                const footerElem = document.querySelector("footer");
                if (footerElem) {
                  footerElem.classList.remove("d-none");
                }
              }, 500); 
              return () => clearTimeout(timer);
            }else{
              const f = document.querySelector('footer');
            if (f) f.classList.add('d-none');
            }
          }, [sectionsData]);

  return (
    <>     
     {showLoader && (
        <div className={`layout-loader${fadeOut ? " fade-out" : ""}`}>
          <span className="loader" />
        </div>
      )}

      {sectionsData.map((section, index) => {
        switch (section.section) {
          case 1:
            return (
              <Section1
                key={index}
                contenuti={section.contenuti}
                breadCrumbs={section.breadCrumbs}
              />
            );
          case 7:
            return (
              <Section7
                key={index}
                contenuti={section.contenuti}
                cards={section.cards}
              />
            );
          case 4:
            return <Section4 key={index} contenuti={section.contenuti} />;
          case 6_1:
            return (
              <Section6_1
                key={index}
                contenuti={section.contenuti}
                cards={section.cards}
              />
            );
            default:
              return null;
        }
      })}

    </>
  );
};

export default Azienda;
